<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="switchStep" novalidate @input="productAcivateUpdateFlag('salesChannels')">
                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave" v-if="getSelectedItem !== null" :disabled="$v.$invalid">Save</button>
                            <!-- <button class="btn green wider mr-3" @click="readyToSave">Save</button> -->
                            <button type="button" class="btn blue wider" @click="nextStep" :disabled="$v.$invalid">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>

                        <div class="px-4">
                            <div class="row">
                                <div class="col-sm-8">
                                    <div class="panel shaded">

                                        <h5>Sales channel permissions</h5>

                                        <div class="fs-small dark mt-2 mb-3">
                                            Select the sales channel were this product will be available for sale
                                        </div>



                                        <div class="form-group pt-4 channelOptions">
                                            <div class="full mb-3 pRelative mb-3" v-for="salesChannel, index in form.channelCommissions">
                                                <div class="d-flex align-items-center justify-content-between">

                                                    <div class="">
                                                        <div class="d-flex align-items-center mt-3">
                                                            <checkbox v-model="salesChannel.isActive" @input="salesChannelStateChanged(salesChannel)" class="mt-1">
                                                                {{salesChannel.channelName}}
                                                            </checkbox>

                                                            <div v-if="salesChannel.channelType == 50" class="ml-2">
                                                                <v-select :options="agentsChannelOptions" :disabled="!salesChannel.isActive" v-model="selectedAgentsChannelOptions" @input="agentsChannelOptionsChanged($event, salesChannel)"></v-select>
                                                            </div>

                                                        </div>

                                                        <div v-if="salesChannel.channelType == 50">
                                                            <!-- <div class="ml-3 d-flex align-items-center">
                                                                <checkbox v-model="form.salesPermissionsAgentsCustom" @input="customAgentSelectionChanged">
                                                                    <span class="fs-smaller bold">Custom selection</span>
                                                                </checkbox>
                                                                <i class="ico fs-normal dark pointer ml-2" :class="{'ico-arrow-top':form.customAgentSelectionVisible, 'ico-arrow-bottom':!form.customAgentSelectionVisible}" @click="toggleCustomAgentSelectionVisibility"></i>
                                                            </div> -->

                                                            <div class="d-flex flex-column pRelative ml-4" v-if="form.salesPermissionsAgentsCustom">

                                                                <!-- <div class="d-flex justify-content-bewtween">
                                                                    <label class="originalLabel">
                                                                        New Agents are allowed to sell this product:
                                                                    </label>
                                                                    <toggle-button
                                                                        class="ml-auto"
                                                                        v-model="form.agentsInFutureAreAllowed"
                                                                        :labels="{checked: 'YES', unchecked: 'NO'}"/>
                                                                    </span>
                                                                </div> -->

                                                                <agent-white-list
                                                                    class="mt-2" 
                                                                    :allowedList="form.salesPermissionsAgentsList"
                                                                    :blockedList="form.salesBlockedAgentList"
                                                                    :startAllSelected="customAgentListSelectAll"
                                                                    @input="agentListChanged">
                                                                </agent-white-list>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div class="align-self-start">
                                                        <div class="d-flex ">
                                                            <div class="mr-4">
                                                                <span class="dark fs-small bold">Product Ticket</span>
                                                                <div class="d-flex">
                                                                    <input type="number" class="glued-right" style="width: 80px;" v-model="salesChannel.productAmountValue">
                                                                    <v-select class="glued-left" style="width: 50px;" v-model="salesChannel.productAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged(salesChannel, index, 'productAmountType')"></v-select>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <span class="dark fs-small bold">Extras</span>
                                                                <div class="d-flex">
                                                                    <input type="number" class="glued-right" style="width: 80px;" v-model="salesChannel.componentAmountValue">
                                                                    <v-select class="glued-left" style="width: 50px;" v-model="salesChannel.componentAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged(salesChannel, index, 'componentAmountType')"></v-select>
                                                                </div>
                                                            </div>
                                                            <!-- Hidden form now, now transport commissions are enabled for now but they will be -->
                                                            <!-- <div class="ml-4">
                                                                <span class="dark fs-small bold">Transport</span>
                                                                <div class="d-flex">
                                                                    <input type="number" class="glued-right" style="width: 80px;" v-model="salesChannel.transportAmountValue">
                                                                    <v-select class="glued-left" style="width: 50px;" v-model="salesChannel.transportAmountType_helper_selected" :options="getPercentageOrCurrency" @input="commissionTypeChanged(salesChannel, index, 'transportAmountType')"></v-select>
                                                                </div>
                                                            </div> -->
                                                        </div>
                                                    </div>

                                                </div>





                                            </div>

                                        </div>


                                    </div>

                                </div>


                                <div class="col-sm-4">
                                    <div class="panel shaded">
                                        <h5>Booking confirmation</h5>

                                        <div class="form-group row">
                                            <div class="col-sm-12">
                                                <label class="full">
                                                    <span class="d-flex">
                                                        Manual confirmation
                                                    <toggle-button
                                                        class="ml-auto"
                                                        v-model="form.hasManualConfirmation"
                                                        :labels="{checked: 'YES', unchecked: 'NO'}"/>
                                                    </span>

                                                    <div class="fs-smaller mt-2 normal">
                                                        If this option is
                                                        <span class="underlined">enabled</span>
                                                        , every booking coming from customers and
                                                        agents is not confirmed until you manually accept it.
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave" v-if="getSelectedItem !== null" :disabled="$v.$invalid">Save</button>
                            <!-- <button class="btn green wider mr-3" @click="readyToSave">Save</button> -->
                            <button type="button" class="btn blue wider" @click="nextStep" :disabled="$v.$invalid">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Steps from './ProductSteps'
    import extendedVSelect from '@/extends/vue-select'
    import { requiredIf, withParams, numeric } from 'vuelidate/lib/validators'
    import AgentWhiteList from './components/AgentWhiteList'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 4,
                form: {},
                selectedPayment: null,
                selectedDeposit: null,
                agentsChannelOptions: [
                    {
                        label: 'All Agents',
                        value: false
                    },
                    {
                        label: 'Agent Selection',
                        value: true
                    }
                ],
                selectedAgentsChannelOptions: {
                    label: 'All Agents',
                    value: false
                },
                originalSalesChannels: null
            }
        },
        validations: {
            salesChannelsAgent: {
                validateAgentChannel() {
                    return this.validateSalesChannelAgents
                }
            }
        },
        created: function() {
            this.form = JSON.parse(JSON.stringify(this.getClonedItem));

            if(this.form.salesPermissionsAgentsList == undefined){
                this.$set(this.form, 'salesPermissionsAgentsList', [])
            }
            if(this.form.salesBlockedAgentList == undefined){
                this.$set(this.form, 'salesBlockedAgentList', [])
            }

            //set the correct selectedAgentListType from the value on agentsInFutureAreAllowed
            if(this.agentListTypes){
                this.selectedAgentListType = this.agentListTypes.filter(listType => {
                    return listType.value == this.form.agentsInFutureAreAllowed
                })[0]
            }

            //add sales channel helpers
            this.addSalesChannelHelpers()


            //starts with custom agent selection collapsed
            this.setCorrectCustomAgentDropdown()


            //saves a copy of the saleschannels, this is used to check on %/€ change if they are diferent to trigger update flags
            this.originalSalesChannels = JSON.parse(JSON.stringify(this.form.channelCommissions))
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'getPercentageOrCurrency',
                'getSalesChannels'
            ]),
            symbol: function() {
                return this.selectedDeposit.symbol;
            },
            customAgentListSelectAll: function(){
                if(this.getSelectedItem == null){
                    //is creting new product
                    return true
                } else {
                    return null
                }
            },
            validateSalesChannelAgents: function () {
                let agentsChannel = this.form.channelCommissions.filter(channel => {
                    return channel.channelType == 50
                })

                if (agentsChannel.length > 0) {
                    agentsChannel = agentsChannel[0]
                } else {
                    return false
                }

                if(agentsChannel.isActive && this.form.salesPermissionsAgentsCustom == true && this.form.salesPermissionsAgentsList.length == 0){
                    return false
                } else {
                    return true
                }
            },
        },
        methods: {
            formatValue: function() {
                if (this.form.paymentValue !== undefined) {
                    this.form.paymentValue = parseFloat(this.form.paymentValue).toFixed(2);
                }
            },
            agentListChanged: function(agentList) {
                this.$set(
                    this.form,
                    'salesPermissionsAgentsList',
                    agentList.filter(agent => {
                        return agent.selected == true
                    })
                )

                this.$set(
                    this.form,
                    'salesBlockedAgentList',
                    agentList.filter(agent => {
                        return !agent.selected || agent.selected == false
                    })
                )

                this.productAcivateUpdateFlag('salesChannels');
            },
            agentsChannelOptionsChanged: function($event, salesChannel) {
                // salesChannel.isActive = true
                this.form.salesPermissionsAgentsCustom = $event.value
                if($event.value == false){
                    this.form.salesPermissionsAgentsList = []
                    this.form.salesBlockedAgentList = []
                }
            },
            salesChannelStateChanged: function (channel) {
                if(channel.channelType == 50 && channel.isActive == false){
                    this.selectedAgentsChannelOptions = this.agentsChannelOptions[0]
                }
            },
            addSalesChannelHelpers: function () {
                //sort channelType
                this.form.channelCommissions = this.form.channelCommissions.sort(function(salesChannelA, salesChannelB) {
                    if(salesChannelA.channelType > salesChannelB.channelType){
                        return -1;
                    } else{
                        return 1;
                    }
                })

                //sort type
                this.form.channelCommissions = this.form.channelCommissions.sort(function(salesChannelA, salesChannelB) {
                    if(salesChannelA.channelType == 0 || salesChannelA.channelType == 9999){
                        return -1;
                    } else{
                        return 1;
                    }
                })

                this.form.channelCommissions.map(salesChannel => {
                    // sets Type helper
                    salesChannel.productAmountType_helper_selected = this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return salesChannel.productAmountType == percentageOrCurrency.id
                    })[0]
                    salesChannel.componentAmountType_helper_selected = this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return salesChannel.componentAmountType == percentageOrCurrency.id
                    })[0]
                    salesChannel.transportAmountType_helper_selected = this.getPercentageOrCurrency.filter(percentageOrCurrency => {
                        return salesChannel.transportAmountType == percentageOrCurrency.id
                    })[0]

                    if(salesChannel.channelName){
                        salesChannel.name = salesChannel.channelName
                    }
                })
            },
            customAgentSelectionChanged: function (e) {
                //if the custom selection is activated the agent picket opens
                if(e == true){
                    this.form.customAgentSelectionVisible = true
                }
            },
            setCorrectCustomAgentDropdown: function (){
                if(this.form.salesPermissionsAgentsList && this.form.salesPermissionsAgentsList.length > 0){
                    this.$set(this.form, 'customAgentSelectionVisible', true)
                    this.selectedAgentsChannelOptions = this.agentsChannelOptions[1]
                } else {
                    this.$set(this.form, 'customAgentSelectionVisible', false)
                }

            },
            toggleCustomAgentSelectionVisibility: function () {
                this.form.customAgentSelectionVisible = !this.form.customAgentSelectionVisible
            },
            commissionTypeChanged: function(salesChannel, index, target){
                let helper = target+'_helper_selected'
                let setTo = target
                salesChannel[setTo] = salesChannel[helper].id

                // check if was changed
                let originalVal = this.originalSalesChannels[index][helper].id
                let newVal = salesChannel[setTo]
                if(originalVal != newVal){
                    this.productAcivateUpdateFlag('salesChannels')
                }
            },
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step) ) ? step : (this.currentStep - 1) });
            },
            nextStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
            }
        },
        components: {
            Steps,
            vSelect: extendedVSelect,
            AgentWhiteList
        }
    }
</script>

<style lang="scss" scooped>
@import '../../../assets/scss/_variables.scss';
@import '../../../assets/scss/_utility.scss';
.channelOptions label:not(.vue-js-switch, .originalLabel){
    color: $darker !important;
    @extend .fs-normal;
}


</style>



// WEBPACK FOOTER //
// ProductChannels.vue?3545cc3c